import type { Components } from "@mui/material/styles";

export const MuiTable: Components["MuiTable"] = {
  styleOverrides: {
    root: {
      position: "sticky",
    },
  },
};
